const getters = {
	// data
	getListTransaksiKonsumen: (state) => state.listTransaksiKonsumen,
	getInfoTransaksiKonsumen: (state) => state.infoTransaksiKonsumen,
	getDetailTransaksi: (state) => state.detailTransaksi,
	getDetailLayananTransaksi: (state) => state.detailLayananTransaksi,
	getStatusTransaksi: (state) => state.statusTransaksi,
	getDetailPengantaranExtra: (state) => state.detailPengantaranExtra,

	// filter
	getPagination: (state) => state.pagination,
	getSearch: (state) => state.search,
	getIsSearch: (state) => state.isSearch,

	getScrollPosition: (state) => state.scrollPosition,
}

export default getters